import React from "react";
import clsx from "clsx";
import { buildURL } from "../../../../marketplace-next/src/utils/image/cloudinary";
import { FooterItemUrlType } from "../../../types/footer";
import { contructItemUrl } from "./helpers";
import { ICON_SIZE, ICON_MODS } from "./constants";
export var ItemLink = function (_a) {
    var _b, _c;
    var className = _a.className, label = _a.label, url = _a.url, urlType = _a.urlType, image = _a.image, preLabel = _a.preLabel, isBold = _a.isBold, useAltColors = _a.useAltColors;
    var hasImage = Boolean(image);
    var isEmail = urlType === FooterItemUrlType.Email;
    var isPhone = urlType === FooterItemUrlType.Phone;
    var isWhatsapp = urlType === FooterItemUrlType.Whatsapp;
    var baseClass = "block hover:underline py-2 md:py-0 md:text-sm";
    var itemClass = clsx(className, baseClass, {
        "text-text-primary": !isEmail && !useAltColors,
        "text-primary-200": isEmail && !useAltColors,
        "text-white": useAltColors,
        "text-sm": !(isPhone && isWhatsapp),
        "text-base md:text-base": isPhone || isWhatsapp,
        "font-semibold": isBold,
        "flex items-center": hasImage,
    });
    var href = contructItemUrl(url, urlType);
    var usePreLabel = preLabel && preLabel.trim().length;
    var imageAlt = (_b = image === null || image === void 0 ? void 0 : image.alt) !== null && _b !== void 0 ? _b : "";
    var imageUrl = (_c = image === null || image === void 0 ? void 0 : image.url) !== null && _c !== void 0 ? _c : "";
    return (React.createElement(React.Fragment, null,
        usePreLabel && React.createElement("span", { className: "block text-text-primary text-sm" }, preLabel),
        React.createElement("a", { href: href, className: itemClass, target: isWhatsapp ? "_blank" : "_self", rel: "noreferrer noopener", "data-testid": "item-link" },
            hasImage && (React.createElement("img", { src: buildURL(imageUrl, ICON_MODS), alt: imageAlt, className: "mr-2 inline-block", width: ICON_SIZE, height: ICON_SIZE, loading: "lazy" })),
            label)));
};
//# sourceMappingURL=ItemLink.js.map